import {FirebaseTopicModel} from "../firebase-topic-model";
import IFirebaseJackpotBetFeedsData
    from "../../../../../common/interfaces/jackpot-bets/jp-bets-feed-update-firebase-data.interface";

export class JackpotBetsFeedsTopicModel extends FirebaseTopicModel<IFirebaseJackpotBetFeedsData, IFirebaseJackpotBetFeedsData> {
    getTopicName(): string {
        const brandId = this.services.sdk.getBrandID().toString();
        const currency = this.services.currency.currencyIso3;
        return `jackpotFeedNotification/${brandId}_${currency}`;
    }

    getTopicLabel(): string {
        return "JackpotBetsFeed";
    }

    protected _mapRawMessageToPublishMessage(rawMessage: IFirebaseJackpotBetFeedsData): IFirebaseJackpotBetFeedsData {
        return rawMessage;
    }

    private _lastAnalyticsReportTimestamp: number = 0;
    protected notifyListeners(rawMessage: IFirebaseJackpotBetFeedsData) {
        super.notifyListeners(rawMessage);

        if(this._lastAnalyticsReportTimestamp + 30000 < Date.now()) {
            this.analytics.sendMessageUpdate(this.getTopicLabel(), JSON.stringify(rawMessage));
            this._lastAnalyticsReportTimestamp = Date.now();
        }

    }

    protected async _isEnabled(): Promise<boolean> {
        return await super._isEnabled() && this.services.jackpotBet.isEnabled;
    }


}